<template>

  <table class="text-center table table-responsive-sm table-responsive-md table-striped">
    <thead>
    <tr>

      <th v-if="showFieldManager('table-field-order-id')" class=" table-field-order-id">
        <order-table-filter filter-column="id">
          شناسه سبد
        </order-table-filter>
      </th>
      <th v-if="showFieldManager('table-field-order-user')" class=" table-field-order-user">کاربر</th>
      <th v-if="showFieldManager('table-field-order-price')" class=" table-field-order-price">
        <order-table-filter filter-column="paying_amount">
          پرداختی
        </order-table-filter>
      </th>
      <th v-if="showFieldManager('table-field-order-payment-status')" class=" table-field-order-payment-status">وضعیت پرداخت</th>
      <th v-if="showFieldManager('table-field-order-status')" class=" table-field-order-status">وضعیت سبد</th>
      <th v-if="showFieldManager('table-field-order-created-at')" class=" table-field-order-created-at">
        <order-table-filter filter-column="created_at">
          تاریخ ساخت
        </order-table-filter>
      </th>
      <th v-if="showFieldManager('table-field-order-updated-at')" class=" table-field-order-updated-at">
        <order-table-filter filter-column="updated_at">
          تاریخ به روزرسانی
        </order-table-filter>
      </th>
      <th v-if="showFieldManager('table-field-order-payment-date')" class=" table-field-order-payment-date">تاریخ پرداخت</th>
      <th v-if="showFieldManager('table-field-order-items')" class=" table-field-order-items">ایتم ها</th>
      <th v-if="showFieldManager('table-field-order-description')" class=" table-field-order-description">توضیحات سفارش</th>
      <th v-if="showFieldManager('table-field-order-actions')" class=" table-field-order-actions">#</th>
      <th v-if="showFieldManager('table-field-order-comments')" class=" table-field-order-comments">نظردادن</th>

    </tr>
    </thead>
    <tbody>
    <tr v-for="item in items">
      <th v-if="showFieldManager('table-field-order-id')" class=" table-field-order-id"><span class="text-wrap">{{ item.id }}</span></th>
      <th v-if="showFieldManager('table-field-order-user')" class=" table-field-order-user"><span class="text-wrap">{{
          item.user.name
        }} {{ item.user.last_name }}</span>
      </th>
      <th v-if="showFieldManager('table-field-order-price')" class=" table-field-order-price"><span class="text-wrap">{{
          formatNumber(item.paying_amount)
        }}</span></th>
      <th v-if="showFieldManager('table-field-order-payment-status')" class=" table-field-order-payment-status"><span
          class="text-wrap">{{ item.payment_status.status_name }}</span>
      </th>
      <th v-if="showFieldManager('table-field-order-status')" class=" table-field-order-status">
        <select v-if="item.payment_status.status_id==2 && ($store.getters['User/isAdmin'] || isUserStore)"
                @change="setDataForChangeOrderStatus(item)"
                v-model="item.status.status_id" class="form-control">
          <option class="text-dark" v-for="(order_status_item,index) in getOrderStatus" v-if="index >0"
                  :value="index">
            {{ order_status_item }}
          </option>
        </select>

        <span v-else>{{ item.status.status_name }}</span>

      </th>
      <th v-if="showFieldManager('table-field-order-created-at')" class=" table-field-order-created-at">
        <span v-html="addEnterBetweenDateAndTime(item.created_at)" dir="ltr"></span>
      </th>
      <th v-if="showFieldManager('table-field-order-updated-at')" class=" table-field-order-updated-at">
        <span v-html="addEnterBetweenDateAndTime(item.updated_at)" dir="ltr"></span>
      </th>
      <th v-if="showFieldManager('table-field-order-payment-date')" class=" table-field-order-payment-date">
         <span v-if="item.transaction != null"
               v-html="addEnterBetweenDateAndTime(item.transaction.updated_at)"
               dir="ltr"></span>
      </th>
      <th v-if="showFieldManager('table-field-order-items')" class=" table-field-order-items">
        <p v-for="order_item in item.items" class="d-block my-3">
          {{ order_item.product.name }} (تعداد: {{ order_item.quantity }})
        </p>
      </th>
      <th v-if="showFieldManager('table-field-order-description')" class=" table-field-order-description">
        <span v-html="manageOrderDescription(item)"></span>
      </th>
      <th v-if="showFieldManager('table-field-order-actions')" class=" table-field-order-actions">

        <div class="">

          <b-icon icon="trash" class="mr-3 h5" @click="removeOrder(item)" v-if="isAdmin"></b-icon>

          <div v-if="item.order_type == 2">
            <router-link target="_blank"
                         :to="{ name: 'LoanItems', params: { user:item.user.id,order:item.id }}">
              <b-icon icon="person-lines-fill" class="mr-3 h5"></b-icon>
            </router-link>

            <router-link target="_blank" v-if="isAdmin || isUserStore"
                         :to="{ name: 'updateOrder', params: { id: item.id } }">
              <b-icon icon="pen-fill" class="mr-3 h5"></b-icon>
            </router-link>

          </div>

          <div class="" v-else>
            <div v-if="item.payment_status.status_id==2">

        <span class="h5">
          <router-link target="_blank"
                       :to="{ name: 'Factor', params: { orderId: item.id } }"
          >
            <b-icon icon="basket-fill" class="mr-3"></b-icon>
          </router-link>
        </span>

              <span v-if="item.status.status_id >= 2" class="h5"
                    v-b-modal="`general-info-${item.id}`">
        <b-icon :variant="`${(item.shipment_code === null || item.shipment_code=='' ) ? '':'success'}`"
                icon="pen" class="mr-3"></b-icon>
        </span>


              <b-modal :id="`general-info-${item.id}`" hide-footer>
                <div class="text-right">

                  <form @submit.prevent="updateOrderGeneralInfo(item)">


                    <b-form-group
                        id="input-group-1"
                        label="کد مرسوله"
                        label-for="input-1"
                        class="mb-4 mt-3">
                      <b-form-input
                          v-model="item.shipment_code"
                          type="text"
                          placeholder="کد مرسوله"
                          class=" text-left"
                          :class="{ invalid }"
                      ></b-form-input>
                    </b-form-group>

                    <b-button class="btn w-100 my-2 btn-success" pill type="submit">ثبت</b-button>

                  </form>


                </div>
              </b-modal>

            </div>

            <div v-else>

        <span class="h5" v-if="findAttributeOnSiteInfo('show_pre_factor')[0] == 1">
          <router-link target="_blank"
                       :to="{ name: 'Factor', params: { orderId: item.id } }">
            <b-icon icon="basket-fill" class="mr-3"></b-icon>
          </router-link>
        </span>
            </div>

            <router-link target="_blank" v-if="isAdmin || isUserStore"
                         :to="{ name: 'updateOrder', params: { id: item.id } }">
              <b-icon icon="pen-fill" class="mr-3 h5"></b-icon>
            </router-link>
            <router-link target="_blank"
                         :to="{ name: 'FactorWithSlug', params: { slug: item.slug } }">
              <b-icon icon="card-text" class="mr-3 h5"></b-icon>
            </router-link>

          </div>


        </div>
      </th>
      <th v-if="showFieldManager('table-field-order-comments')" class=" table-field-order-comments">
        <m-comment-create-modal-1 :custom_button="true" :commentable_id="item.id" commentable_type="order">
          <template #modal-button>

            <b-button variant="transparent" class=" border-0" v-b-modal="'create-comment-'+item.id"
                      v-if="item.status.status_id === 4">
              <b-icon class="box bounce-7" icon="chat-square-text-fill"/>
            </b-button>

          </template>
        </m-comment-create-modal-1>
      </th>
    </tr>
    </tbody>
  </table>

</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {order_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import OrderTableFilter from "@/plugin/components/dashboard/orders/OrderTableFilter.vue";

export default {
  name: "tableItemOfOrders",
  components: {OrderTableFilter, FormGroup, FormErrorsManager,},
  props: {
    items: {
      default: []
    },
    restoreState: {},
    activeTableField: {
      default: '*'
    }
  },
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه سبد"},
        {key: "user", label: "کاربر"},
        {key: "paying_amount", label: "پرداختی"},
        {key: "payment_status", label: "وضعیت پرداخت"},
        {key: "status", label: "وضعیت سبد"},
        {key: "shopping_cart_created_at", label: "تاریخ ساخت سبد"},
        {key: "shopping_cart_updated_at", label: "تاریخ به روزرسانی"},
        {key: "transaction_date", label: "تاریخ پرداخت"},
        {key: "items", label: "ایتم های سفارش"},
        {key: "action", label: ""},
        {key: "comment", label: "نظر دادن"}
      ],
      order_status,
      order_id: '',
      commentForm: {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        [{color: []}]
      ],
      filter: {
        currentFilterName: '',
        filterType: 'asc'
      }
    };
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin',
      isUserStore: 'User/isUserStore',
    }),
    getOrderStatus() {
      return this.order_status;
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeOrderStatus(item) {
      const order_id = item.id;
      const status = item.status.status_id;
      this.changeOrderStatus({order_id, status});

    },
    formatNumber,
    dateConverter,
    addEnterBetweenDateAndTime(date) {
      date = this.dateConverter(date, '/', true);
      return date.replace(' ', '<br>')
    },
    setOrderId(id) {
      this.order_id = id
      this.commentForm.commentable_id = id
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1
      }
      this.$store.dispatch("Comment/createComment", this.commentForm).then(res => {
        toast('', 'کامنت شما با موفقیت ثبت شد و در انتظار برای تایید قرار گرفت')
      })
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.createComment()
        this.$nextTick(() => {
          this.$bvModal.hide('comment-' + this.order_id)
          this.resetCommentForm()
        })
      }
    },
    updateOrderGeneralInfo(data) {
      const form = {
        order_id: data.id,
        shipment_code: data.shipment_code,
      }
      this.$store.dispatch('ShoppingCart/updateOrderGeneralInfo', form)
    },
    removeOrder(order) {
      if (confirm('ایا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('Transaction/removeOrder', order).then(res => {
          this.$store.dispatch("ShoppingCart/getAllOrders")
        })
      }
    },
    manageOrderDescription(item) {
      let orderDescription = item.description
      try {
        let descriptionJson = JSON.parse(orderDescription);

        let result = "";

        for (let key in descriptionJson) {
          result += `${key}: ${descriptionJson[key]} <br>`;
        }
        return result
      } catch (e) {
        return orderDescription
      }

    },
    showFieldManager(fieldName) {
      if (this.activeTableField === '*') return true
      return this.activeTableField.indexOf(fieldName) > -1
    }
  },

};
</script>

<style scoped>

.box {
  align-self: flex-end;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  background-color: transparent;
  color: orange;
  margin: 0 auto 0 auto;
  transform-origin: bottom;

}

.bounce-7 {
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
}

@keyframes bounce-7 {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(1.1, .9) translateY(0);
  }
  30% {
    transform: scale(.9, 1.1) translateY(-17px);
  }
  50% {
    transform: scale(1.05, .95) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(-7px);
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}

.rate-s {
  height: 40px !important;
  width: max-content !important;
}

</style>